import AvailabilityPage from './Availability';

export default AvailabilityPage;
